var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name != 'Open')?_c('tr',[_c('th',[_vm._v(_vm._s(_vm.name)+" Date")]),_c('td',[_vm._v(_vm._s(_vm._f("formatUnixDateTime")(_vm.date)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }